export * from './CrossDomainStorage';
